import { useEffect } from "react";

// Marketing-look theme is the global default. The `.theme-v2` class is
// applied to <html> on every mount so v2 utility classes (.v2-hex-bg,
// .v2-neon-card, .v2-neon-cta etc.) cascade everywhere.
//
// We do NOT force the `.dark` class here. SessionProvider owns the
// light / dark / auto reconciliation — forcing `.dark` here would clobber
// the user's choice and stop the system-preference auto mode working.
export function V2ThemeProvider() {
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.classList.add("theme-v2");
  }, []);

  return null;
}
